import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { PaymentsService } from 'src/app/services/payments-services/payments.service';
import { Gateway } from 'src/app/models/gateways-models/gateway.model';

@Component({
  selector: 'app-payments-gateways-breadcrumb-filter-card',
  templateUrl: './payments-gateways-breadcrumb-filter-card.component.html',
  styleUrls: ['./payments-gateways-breadcrumb-filter-card.component.scss']
})
export class PaymentsGatewaysBreadcrumbFilterCardComponent implements OnInit {

  @Input() gateways;
  providers;
  types;
  providersForm = new FormGroup({});
  typesForm = new FormGroup({});

  constructor(private userStorageService: UserStorageService,
              private paymentsService: PaymentsService) { }

  ngOnInit() {
    this.getProviders();
    this.getTypes();
    if (this.userStorageService.getFilterGateways()) {
      this.providersForm.patchValue(this.userStorageService.getFilterGateways()['providersForm']);
      this.typesForm.patchValue(this.userStorageService.getFilterGateways()['typesForm']);
    }
    this.filter();
  }

  public updateCheckbox(form, reset?) {
    this._toggleCheckboxes(form, reset);
  }

  private _toggleCheckboxes(form, reset) {
    if (reset && form.get('all').value) {
      Object.entries(form.controls).forEach(p => (p[0] !== 'all') ? (p[1] as FormControl).setValue(false) : null);
    } else if (Object.entries(form.controls).find(p => (p[0] !== 'all') && (p[1] as FormControl).value)) {
      form.get('all').setValue(false);
    } else if (!Object.entries(form.controls).find(p => (p[1] as FormControl).value)) {
      form.get('all').setValue(true);
    }
    this.userStorageService.setFilterGateways({ providersForm: this.providersForm.getRawValue(), typesForm: this.typesForm.getRawValue() });
    if (this.userStorageService.getFilterGateways()['providersForm']['all'] && this.userStorageService.getFilterGateways()['typesForm']['all']) {
      this.userStorageService.deleteFilterGateways();
    }
    this.filter();
  }

  private getProviders() {
    const providers = new Array<string>();
    this.providersForm.addControl('all', new FormControl(true));
    this.gateways.forEach((g: Gateway) => {
      if (providers.indexOf(g.Gateway.Description) === -1) {
        providers.push(g.Gateway.Description);
        this.providersForm.addControl(g.Gateway.Description, new FormControl(false));
      }
    });
    this.providers = providers;
  }

  private getTypes() {
    const types = new Array<string>();
    this.typesForm.addControl('all', new FormControl(true));
    this.gateways.forEach((g: Gateway) => {
      if (types.indexOf(g.Type.Description) === -1) {
        types.push(g.Type.Description);
        this.typesForm.addControl(g.Type.Description, new FormControl(false));
      }
    });
    this.types = types;
  }

  public filter() {
    const forms = {
      providersForm:
      {
        attribute: 'Gateway.Description',
        values: []
      },
      typesForm:
      {
        attribute: 'Type.Description',
        values: []
      }
    };
    if (this.providersForm.get('all').value) {
      forms['providersForm'].values = Object.keys(this.providersForm.value).splice(1);
    } else {
      Object.entries(this.providersForm.value).forEach(p => { if (p[1]) { forms['providersForm'].values.push(p[0]); }});
    }
    if (this.typesForm.get('all').value) {
      forms['typesForm'].values = Object.keys(this.typesForm.value).splice(1);
    } else {
      Object.entries(this.typesForm.value).forEach(p => { if (p[1]) { forms['typesForm'].values.push(p[0]); }});
    }
    this.paymentsService.filterGateways(forms);
  }
}

